import React, { createContext, useContext, useState } from "react";
import { Check } from "lucide-react";
import BottomSheet from "../ui/bottom-sheet";
import { ICON_STROKE } from "../ui/icon";
import { useLanguage } from "../../contexts/LanguageContext";

const FEATURE_KEYS = ["f1", "f2", "f3", "f4", "f5", "f6", "f7"];

const PremiumFeaturesContext = createContext(null);

export function PremiumFeaturesProvider({ children }) {
  const [open, setOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <PremiumFeaturesContext.Provider value={() => setOpen(true)}>
      {children}
      <BottomSheet
        open={open}
        onClose={() => setOpen(false)}
        title={t("premium.popupTitle")}
        className="sm:max-w-md"
        secondaryAction={{ label: t("premium.popupClose"), onClick: () => setOpen(false) }}
      >
        <p className="text-base leading-snug text-secondary m-0 mb-4">{t("premium.popupIntro")}</p>
        <ul className="m-0 p-0 list-none space-y-3">
          {FEATURE_KEYS.map((key) => (
            <li key={key} className="flex items-start gap-3 text-base leading-snug text-foreground">
              <Check size={18} strokeWidth={ICON_STROKE} className="text-success shrink-0 mt-0.5" aria-hidden />
              <span>{t(`premium.popup.${key}`)}</span>
            </li>
          ))}
        </ul>
      </BottomSheet>
    </PremiumFeaturesContext.Provider>
  );
}

/** Turns the words Premium and प्रीमियम in marketing copy into a link that opens the feature list. */
export function PremiumLinkedText({ text }) {
  const open = useContext(PremiumFeaturesContext);
  const value = String(text ?? "");
  if (!open) return value;
  const parts = value.split(/(Premium|premium|प्रीमियम)/g);
  if (parts.length === 1) return value;
  return parts.map((part, index) =>
    part === "Premium" || part === "premium" || part === "प्रीमियम" ? (
      <button
        key={`${part}-${index}`}
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          open();
        }}
        className="inline p-0 text-primary font-semibold underline underline-offset-2 decoration-primary/40 hover:decoration-primary bg-transparent"
      >
        {part}
      </button>
    ) : (
      <React.Fragment key={`t-${index}`}>{part}</React.Fragment>
    )
  );
}
